export default {
    /**
     * Fetch blogs from the API.
     *
     * @param {object} context
     * @param {object} payload
     * @param {number} payload.page
     * @param {number} payload.pageSize
     * @param {string} payload.locale
     *
     * @returns {object}
     */
    async getBlogPosts(context, { page = 1, pageSize = 9, locale }) {
        const { default: query } = await import('../../queries/blog-posts.graphql');

        const { blogPosts } = await this.$strapi.query(query, {
            page,
            pageSize,
            locale,
        });

        const { formatBlogPosts } = await import('../../lib/blog-posts');

        return {
            blogPosts: {
                data: formatBlogPosts(this, blogPosts.nodes),
                pagination: blogPosts.pageInfo ?? {},
            },
        };
    },

    /**
     * Fetch the recent blog posts from the api, excluding the id provided.
     *
     * @param {object} context
     * @param {object} payload
     * @param {number|string} payload.exclude
     * @param {string} payload.locale
     *
     * @returns {Promise<{posts: Array}>}
     */
    async fetchRecentBlogPosts(context, { exclude, locale }) {
        const { default: query } = await import('../../queries/blog/recent-blog-posts.graphql');

        const { blogPosts } = await this.$strapi.query(query, {
            exclude,
            locale,
        });

        const { formatBlogPosts } = await import('../../lib/blog-posts');

        return {
            posts: formatBlogPosts(this, blogPosts),
        };
    },
};
